module.exports = __webpack_public_path__ + "img/ccf-pt-PT.d5a90449.png";